
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"17","height":"17","rx":"1","fill":"#c4c4c4"}}),_c('path',{attrs:{"d":"M4.75 8.33a.2.2 0 000 .341l5.79 3.519a.2.2 0 00.305-.171V4.98a.2.2 0 00-.304-.17L4.75 8.328z","fill":"#fff"}})])
          )
        }
      }
    